/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'screen_wrench': {
    width: 16,
    height: 16,
    viewBox: '0 0 35.78 41',
    data: '<g data-name="图层 2"><g data-name="图层 1" _fill="none" _stroke="#383e47" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path pid="0" d="M18.23 39.52H1V1h33.13v23.43"/><path pid="1" d="M7.46 20.26l6.33-8.92 6.17 7.16L26.7 9M28.23 25.49A5.64 5.64 0 0022 24.3l3.26 3.26a1 1 0 010 1.37L23.7 30.5a1 1 0 01-1.37 0l-3.26-3.26a5.64 5.64 0 001.24 6.27 5.72 5.72 0 006.15 1.13l4.75 4.75a2.09 2.09 0 102.95-2.95l-4.73-4.74a5.64 5.64 0 00-1.2-6.21z"/></g></g>'
  }
})
